import postDetailBioDefaultImage from "../../../../../../../../media/img/post-details-layout.png";

export const POST_DETAIL_BIO_DEFAULT_IMAGE: string = postDetailBioDefaultImage;

function isUsableImageUrl(url: string): boolean {
  const trimmed = url.trim().toLowerCase();
  return (
    trimmed.length > 0 &&
    trimmed !== "none" &&
    trimmed !== "null" &&
    trimmed !== "undefined"
  );
}

export function resolvePostDetailBioImage(
  url: string | null | undefined
): string {
  if (url == null || !String(url).trim()) {
    return POST_DETAIL_BIO_DEFAULT_IMAGE;
  }

  const raw = String(url).trim();
  const urlMatch = raw.match(/url\(['"]?(.*?)['"]?\)/i);
  const normalized = (urlMatch ? urlMatch[1] : raw).trim();

  if (!isUsableImageUrl(normalized)) {
    return POST_DETAIL_BIO_DEFAULT_IMAGE;
  }

  return normalized;
}
